import { render, staticRenderFns } from "./SystemModulesDetail.vue?vue&type=template&id=e926e874&scoped=true"
import script from "./SystemModulesDetail.vue?vue&type=script&lang=js"
export * from "./SystemModulesDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e926e874",
  null
  
)

export default component.exports